// Single source of truth for the site navigation.
// Both the desktop menu (components/Menu.js) and the mobile drawer
// (components/SideBar.js) render from NAVIGATION, so edit the menu HERE only.
//
// - `label` is a translation key in locales/<lang>/navigation.json
// - `to` is the route path
// - an item with `children` becomes a dropdown (desktop) / accordion (mobile)
// To hide an item temporarily, comment it out.
export const NAVIGATION = [
    { label: 'Home', to: '/' },
    {
        label: 'about us',
        children: [
            { label: 'message from', to: '/about-us/message-from' },
            { label: 'our history', to: '/about-us/our-history' },
            { label: 'our team', to: '/about-us/our-team' },
            // Order: who we are -> what we teach -> accountability -> news -> join us
            { label: 'school curriculum', to: '/school-info/school-curriculum' },
            { label: 'examinations', to: '/school-info/school-curriculum/examinations' },
            { label: 'annual reports', to: '/about-us/annual-reports' },
            { label: 'media news', to: '/about-us/st-marys-in-media-and-news' },
            { label: 'vacancies', to: '/about-us/vacancies' },
        ],
    },
    {
        label: 'school life',
        children: [
            { label: 'school profile', to: '/school-info/school-profile' },
            { label: 'school day & terms', to: '/school-info/school-day-and-terms' },
            { label: 'Calendar', to: '/calendar' },
            { label: 'Gallery', to: '/gallery' },
            { label: 'parent_teacher_association', to: '/school-info/parent-teacher-association' },
        ],
    },
    { label: 'Admissions', to: '/admissions' },
    { label: 'school policies', to: '/school-info/school-policies' },
    { label: 'satellite schools', to: '/satellite-schools' },
    { label: 'Contact Us', to: '/contact-us' },
];

// External links shown as buttons (top bar on desktop, drawer on mobile)
export const SUPPORT_US_URL = 'https://donate.stmarysukrschool.co.uk/donation/custom-donation/';
export const ONLINE_ACADEMY_URL = 'https://stmarys-ukr-academy.co.uk/';
export const TRUST_URL = 'https://ukrainianstmarystrust.com/';
